import { render, staticRenderFns } from "./AttributesRelationList.vue?vue&type=template&id=6d1fe6f3&"
import script from "./AttributesRelationList.vue?vue&type=script&lang=js&"
export * from "./AttributesRelationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports